// The explorer and the inspector: shown or hidden beside the tabs on wide screens, or slid in
// over them (one at a time) on narrow ones.
import { create } from 'zustand';
import { EXPLORER_DOCKS, INSPECTOR_DOCKS, matches } from '../lib/media';

export type Side = 'explorer' | 'inspector';

interface Sidebars {
  /** Docked sidebars that are shown. */
  explorer: boolean;
  inspector: boolean;
  /** The sidebar slid in over the tabs, on narrow screens. */
  drawer: Side | null;
}

export const useSidebars = create<Sidebars>(() => ({ explorer: true, inspector: true, drawer: null }));

export function docks(side: Side): boolean {
  return matches(side === 'explorer' ? EXPLORER_DOCKS : INSPECTOR_DOCKS);
}

export function toggleSidebar(side: Side): void {
  if (docks(side)) useSidebars.setState((s) => ({ [side]: !s[side] }));
  else useSidebars.setState((s) => ({ drawer: s.drawer === side ? null : side }));
}

/** Shows a sidebar, for example the inspector after asking for the details of something. */
export function showSidebar(side: Side): void {
  if (docks(side)) useSidebars.setState({ [side]: true });
  else useSidebars.setState({ drawer: side });
}

export function closeDrawer(): void {
  if (useSidebars.getState().drawer) useSidebars.setState({ drawer: null });
}
